export default __webpack_public_path__ + "static/media/j.crew2.9245d12c.png";